import ReactECharts from 'echarts-for-react';
import { BarChart2 } from 'lucide-react';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { EmptyState } from '@/components/ui/EmptyState';
import { formatBRLCompact } from '@/lib/format';
import type { DailySales } from '@/hooks/useMlOrders';

interface Props {
  data?: DailySales[];
}

export function SalesChart({ data = [] }: Props) {
  const hasData = data.some((d) => d.orders > 0 || d.revenueCents > 0);

  return (
    <div className="card p-5">
      <SectionHeader title="Vendas — últimos 7 dias" subtitle="Pedidos × faturamento bruto" />
      {!hasData ? (
        <EmptyState
          icon={BarChart2}
          title="Sem dados de vendas"
          description="Nenhum pedido nos últimos 7 dias. Os dados sincronizam a cada 5 minutos."
        />
      ) : (
        <ReactECharts
          style={{ height: 280 }}
          option={{
            tooltip: {
              trigger: 'axis',
              valueFormatter: (v: number) => String(v),
            },
            grid: { left: 8, right: 8, top: 32, bottom: 8, containLabel: true },
            legend: { data: ['Faturamento', 'Pedidos'], top: 0 },
            xAxis: { type: 'category', data: data.map((d) => d.day) },
            yAxis: [
              {
                type: 'value',
                axisLabel: { formatter: (v: number) => formatBRLCompact(v) },
              },
              { type: 'value', minInterval: 1 },
            ],
            series: [
              {
                name: 'Faturamento',
                type: 'bar',
                data: data.map((d) => d.revenueCents),
                itemStyle: { color: '#1d4ed8', borderRadius: [4, 4, 0, 0] },
                tooltip: { valueFormatter: (v: number) => formatBRLCompact(v) },
              },
              {
                name: 'Pedidos',
                type: 'line',
                yAxisIndex: 1,
                data: data.map((d) => d.orders),
                itemStyle: { color: '#14a655' },
                smooth: true,
              },
            ],
          }}
        />
      )}
    </div>
  );
}
